import axios from 'axios'
import {ModuleModel, ResponseObjectPaginated} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getModule(dto: ModuleModel, page: number) {
  return axios.post<ResponseObjectPaginated<ModuleModel[]>>(
    `${BASEURL}/application/getAll/${page}`,
    dto,
  )
}
